<template>
<nav class="custom-nav">
    <Mainmenu title="Menu" :items="services"/>
</nav>
</template>

<script>
import Mainmenu from './Mainmenu'

export default{
    name: 'white-navbar',
    components: {
        Mainmenu
    },
     data () {
        return{
            services: [
                {
                    title: 'ΑΡΧΙΚΗ',
                    link: '/'
                },
                {
                    title: 'ΣΧΕΤΙΚΑ',
                    link: '/about/'
                },
                {
                    title: 'ΠΡΟΙΟΝΤΑ',
                    link: '/shop/'
                },
                {
                    title: 'ΕΠΙΚΟΙΝΩΝΙΑ',
                    link:'/contact/'
                },  
                {
                    title: 'ΑΡΧΙΚΗ',
                    link: '/'
                },
                {
                    title: 'ΣΧΕΤΙΚΑ',
                    link: '/about/'
                },
                {
                    title: 'ΠΡΟΙΟΝΤΑ',
                    link: '/shop/'
                },
                {
                    title: 'ΕΠΙΚΟΙΝΩΝΙΑ',
                    link:'/contact/'
                },
                {
                    title: 'ΑΡΧΙΚΗ',
                    link: '/'
                },
                {
                    title: 'ΣΧΕΤΙΚΑ',
                    link: '/about/'
                },
                {
                    title: 'ΠΡΟΙΟΝΤΑ',
                    link: '/shop/'
                },
                {
                    title: 'ΕΠΙΚΟΙΝΩΝΙΑ',
                    link:'/contact/'
                }
            ],
        }
    }

}
</script>
<style >
 nav{
        display: flex;
        align-items: center;
    }

    nav .menu-item{
        color:#fff;
        position: relative;
        text-align:center;
        border-bottom: 3px solid transparent;
        display: flex;
        transition: 0.4s;
    }

    nav .menu-item a{
        color:inherit;
        text-decoration:none;
    }
</style>